import { useState } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { isEmpty } from "lodash";
import { useAppSelector } from "../redux-store/CustomReduxHooks";
import CustomPopup from "../components/CustomPopup/CustomPopup";
import { Colors } from "../styles/constant";

const usePermissionWithPopup = () => {
  const [alertAppUpdate, setAlertAppUpdate] = useState(false);
  const permissionDetails = useAppSelector(
    (state) => state.GeneralAppElementsSlice.appPermission
  );
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);

  type PermissionType =
    | "tncConsent"
    | "privacyConsent"
    | "whatsapp"
    | "camera"
    | "notifications"
    | "contact"
    | "call"
    | "sms"
    | "location"
    | "storage"
    | "displayOverOtherApps";

  const checkPermissions = (permissionTypes: PermissionType[]) => {
    const deviceName = csAppSlice.NativeDeviceInfo?.deviceName;
    const unGrantedPermissions = permissionTypes.filter((permissionType) => {
      const permissionGranted = permissionDetails?.permissions[permissionType];
      return !permissionGranted; 
    });

    if (!isEmpty(deviceName) && unGrantedPermissions.length > 0) {
      setAlertAppUpdate(true);
    }

    return {
      allGranted: unGrantedPermissions.length === 0,
      unGrantedPermissions,
    };
  };

  const closePopup = () => {
    setAlertAppUpdate(false);
  };

  const renderPopUp = () => (
    <CustomPopup handleOpen={() => {}} open={alertAppUpdate}>
      <Box padding="1.5rem 1rem">
        <Box marginTop="1.5rem">
          <Typography textAlign="center" variant="h3">
            Update Permission
          </Typography>
          <Typography
            marginTop="1rem"
            textAlign="center"
            variant="h5"
            paddingX="1.25rem"
            color={Colors.textGray}
          >
            Enable Permission from app settings
          </Typography>
        </Box>
        <Stack direction={"row"}>
          <Button
            fullWidth
            variant="contained"
            sx={{ margin: "1rem .25rem .25rem .25rem" }}
            onClick={closePopup}
          >
            Close
          </Button>
        </Stack>
      </Box>
    </CustomPopup>
  );

  return {
    checkPermissions, 
    renderPopUp,
  };
};

export default usePermissionWithPopup;
